import React from 'react';
import { Link } from 'react-router-dom';

const NotFound = () => {
  return (
    <div className="container my-5">
      <div className="row justify-content-center">
        <div className="col-12 col-md-8 text-center">
          <h1 className="display-1 text-danger">404</h1>
          <h2 className="mb-3">Page Not Found</h2>
          <p className="lead mb-4">
            The page you're looking for doesn't exist.
          </p>
          <Link to="/" className="btn btn-success">
            Go Back to Home
          </Link>
        </div>
      </div>
    </div>
  );
};

export default NotFound;